<template>
    <auth-layout>
        <loading-block v-if="loading" />
        <div class="write-form-wrap mt-5" v-else>
           <form role="form"  method="post" class="form-horizontal" @submit.prevent="postData" style="padding:0px 10px;">
                <div class="form-group" >
                    <label for="kode-voucher">Kode Voucher</label>
                    <input type="text" v-model="form.voucher_name" class="form-control clean-form"   v-bind:class="{ 'is-invalid': errors }"  id="voucher_name" >
                    <div class="invalid-feedback" v-if="errors === true">
                        {{ messages }}
                    </div>
                </div>
                <div class="form-group" >
                <button type="submit" class="btn btn-primary main-button pill-button bg-orange" >CAIRKAN VOUCHER</button>
                </div>
            </form>
        </div>
    </auth-layout>
</template>

<style scoped>
.redeem-page {
    padding: 0 5%;
}
</style>
<script>
import axios from "axios";


export default {
    components: {

    },
    data() {
        return {

            form: {
                voucher_name: ''
            },
            loading: false,
            errors: false,
            messages:[]
        }
    },
    mounted() {

    },
    methods: {
        postData(){
            const token = this.$cookies.get('token');

             const data = this.form;

            this.loading = true;
            axios.post(`/api/voucher/take`, data, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.$notify({
                        duration: 5000,
                        group: 'main',
                        title: response.data.message,
                        text: response.data.description,
                        type: 'success'
                    });

                    this.loading = false;
                })
                .catch((error) => {
                    $('#previewArticle').modal('hide');
                    console.log(error.response.data)
                    this.loading = false;
                    this.errors = true;
                    this.messages =  error.response.data.message;

                });
        },
        getRedeem() {
            const token = this.$cookies.get('token');
            axios.get('/api/redeem', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.redeem = response.data
                    this.loading = false
                })
                .catch((error) => {
                   this.loading = false;
                    this.errors = true;
                });
        }
    }
}
</script>

